var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"area_right3"}},[_c('div',{staticClass:"cc-header"},[_vm._v("访客进出分析 "),_c('div',{staticClass:"view_btn",on:{"click":_vm.showTable}},[_vm._v("访客明细")])]),_c('div',{staticClass:"main-value",attrs:{"id":"visit_inout"}})])}
var staticRenderFns = []

export { render, staticRenderFns }